module.exports = __webpack_public_path__ + "img/6.04096bd6.jpg";